<div *ngIf="activeQuestion" [formGroup]="activeQuestion" class="required-setting__container">
  <mat-slide-toggle
    [class.border]="showBorder"
    [labelPosition]="'before'"
    [color]="'primary'"
    formControlName="requiredInd"
    [checked]="activeQuestion.value.requiredInd"
  >
    Required
  </mat-slide-toggle>
</div>
